import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form'
import moment from 'moment'
import css from './bfm.css';
import Button from '@material-ui/core/Button';
import * as actions from '../../Actions/xpa';
import { required, normalizeAccName } from '../Common/Validation';


class BankFeedDetail extends Component {

    componentDidMount() {
        this.props.editBankFeedName(false);
    }

    componentWillReceiveProps(nextProps) {
        const { feed, accountName, xpa, onFeedUpdate } = this.props;
        if (xpa.updated !== nextProps.xpa.updated) {
            if (nextProps.xpa.updated) onFeedUpdate({...feed, accountName});
        }
    }

    renderDetails = (label, data) => (
        <div className={[css.dFlex, css.pb10, css.font14].join(' ')}>
            <label>{label} :</label>
            <div>{data} </div>
        </div>
    );

    renderField = ({ input, type, meta: { touched, error } }) => (
          <span>
            <input {...input} type={type} disabled={this.props.xpa.updating} />
            {touched && error && <span className={css.validationLabel}>{error}</span>}
          </span>
    );
    
    render() {
        const { feed, downloadForm, onEditYodlee, handleSubmit, pristine, submitting, xpa } = this.props;
        return (
        <div className={css.w400}>
            <div className={[css.dFlex, css.pb10, css.font14, css.alignCenter].join(' ')}>
                <label>Account Name :</label>
                {!xpa.edit && 
                    <div>
                        {feed.accountName}
                        <i class="fas fa-edit" style={{ marginLeft: 10 }} onClick={() => this.props.editBankFeedName(true)}></i>
                    </div>
                }
                {xpa.edit && (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <Field
                                name="accountName"
                                component={this.renderField}
                                type="text"
                                validate={required}
                                normalize={normalizeAccName}
                                placeholder="Account Name" />
                            {xpa.updating ? 
                                <i className="fa fa-sync fa-spin text-muted" style={{ color: '#ccc', padding: '0 5px' }}></i>
                                : <React.Fragment>
                                    <button className={[css.iconButton, css.p3].join(' ')} type="submit" disabled={pristine || submitting}>
                                        <i class="fas fa-check" style={{fontSize: 14}}></i>
                                    </button>
                                    <button className={[css.iconButton, css.font14].join(' ')}  type="button" onClick={() => this.props.editBankFeedName(false)}>
                                        <i class="fas fa-times" style={{fontSize: 14}}></i>
                                    </button>
                                    {xpa.updateError && 
                                        <i class="fas fa-exclamation-circle" style={{color: 'red', marginLeft: 5}}></i>
                                    }
                                  </React.Fragment>}
                        </div>
                    </form>)}

            </div>
            {this.renderDetails('Account Number', (Boolean(feed.bsb && feed.bsb.length)) ? `${feed.bsb.substring(0, 3)}-${feed.bsb.substring(3, 6)} - ${feed.accountNumber}` : feed.accountNumber)}
            {feed.source === 'Yodlee' ? this.renderDetails('Yodlee ID', feed.YodleeItemID) : ''}
            {this.renderDetails('Bank', feed.bank)}
            <div className={[css.dFlex, css.pb10, css.font14].join(' ')}>
                <label>Status :</label>
                <div>
                    {feed.status} 
                    {feed.source === 'Yodlee' && feed.status === 'Active' &&
                        <Button  
                            style={{maxHeight: '20px', minHeight: '20px', paddingTop: '3px', marginLeft: '5px' }} 
                            variant="outlined" 
                            size="small" 
                            color="primary"
                            onClick={onEditYodlee}>
                            <span className={css.font10}>Re-Auth</span>
                        </Button>}
                </div>
                {(feed.formUploaded) && <div className={[css.fontSmall, css.pl10].join(' ')} onClick={() => downloadForm(feed.feedId)}>(<a href="#">Download your form</a>)</div>}
            </div>
            {this.renderDetails('Type', (feed.bsb === '000000') ? 'Credit Card' : 'Bank Account')}
            {this.renderDetails('Source', feed.source)}
            {this.renderDetails('First Transaction', feed.firstTransaction ? moment(feed.firstTransaction).format('DD MMMM YY') : 'No transactions received yet')}
            {this.renderDetails('Last Transaction', feed.lastTransaction ? moment(feed.lastTransaction).format('DD MMMM YY') : '')}
            {feed.sissAccountId && this.renderDetails('Consent Status', feed.sissConsentStatus ? 'Active' : 'Not Active')}
            {feed.sissAccountId && this.renderDetails('Share Status', feed.sissShareStatus ? 'Active' : 'Not Active')}
            {feed.sissAccountId && this.renderDetails('Consent Expiry Date', feed.sissConsentExpiry ? moment(feed.sissConsentExpiry).format('DD MMMM YY') : '')}
            {feed.sissAccountId && this.renderDetails('Share Expiry Date', feed.sissShareExpiry ? moment(feed.sissShareExpiry).format('DD MMMM YY') : '')}
        </div>
    )}
};

const selector = formValueSelector('bankFeedDetail');

function mapStateToProps(state) {
    const { xpa } = state;
    return { xpa, accountName: selector(state, 'accountName') };
  }

export default BankFeedDetail = connect(
    mapStateToProps,
    actions
  )(
    reduxForm({
        form: 'bankFeedDetail'
    })(BankFeedDetail)
  );


// WEBPACK FOOTER //
// ./src/components/FeedManagment/BankFeedDetails.js